import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        width: "100%",
    },
    stepImage: {
        width: 25,
    },
    stepImageSmall: {
        width: 17,
    },
    stepperContainer: {
        width: 500,
        [theme.breakpoints.down("desktop")]: {
            width: "100%",
        },
    },
    content: {
        width: "100%",
        paddingTop: 20,
        [theme.breakpoints.down("desktop")]: {
            paddingLeft: 20,
            paddingRight: 20,
        },
    },
}));

export default useStyles;
